export class GprsDiagnosis {
  public rssi;
  public data;
  public available;
  public isRunning;
  public gprsData;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/gprs-diagnosis.ts